export enum StatusHistory {
    approved = 'APPROVED',
    rejected = 'REJECTED',
    inApproval = 'IN_APPROVAL',
    draft = 'DRAFT',
    discontinued = 'DEPRECATED',
    created = 'CREATED',
    modified = 'MODIFIED'
}
